import { ThemeOptions } from "@mui/material";

// The app's dark palette comes from design's tokens via the Kaizen theme's
// `colorSchemes.dark` (`paletteFor(dark)`). These alias the resulting CSS vars
// so the mapping below stays token-driven rather than hardcoding colors, and
// follows whatever design ships for the dark tokens.
const darkSchemeVars = {
  surface: "var(--ds-mui-palette-background-paper)",
  border: "var(--ds-mui-palette-divider)",
} as const;

/**
 * The app-layer dark-scheme wiring, composed over the app theme in the Kaizen
 * theme only. Design's tokens supply the palette values (`colorSchemes.dark`);
 * this supplies the one thing tokens can't reach, the app's custom `surfaces`
 * namespace. It resolves to `--ds-mui-palette-*` vars, so it stays in step with
 * design's dark tokens.
 */
export const kaizenDarkSchemeOptions: ThemeOptions = {
  colorSchemes: {
    dark: {
      palette: {
        // Custom surface namespace read by feature styled-components (e.g. the
        // RFP-draft card's left rail and avatar); tokens have no equivalent,
        // so map it onto the token dark surface/divider vars.
        surfaces: {
          high: darkSchemeVars.surface,
          neutral: darkSchemeVars.border,
          primary: darkSchemeVars.surface,
          secondary: darkSchemeVars.surface,
        },
      },
    },
  },
};
